<template>
  <div class="h-full">
    <loader :loading="loading" :backdrop="true" />
    <div class="form-row w-full">
      <FinalForm
        :submit="saveData"
        :initialValues="initialValues"
        class="w-full form-col-2 pr-2"
        ref="form"
      >
        <div class="stick bg-white pb-3 z-10">
          <div class="form-row">
            <label class="font-semibold" style="color: var(--highlightColor500)"
              >rent consessions</label
            >
          </div>
        </div>
        <div>
          <label class="form-section-sub-title"
            >rent consession or other rent discount</label
          >
          <div class="form-row">
            <button>
              <CheckboxInputSmall
                type="checkbox"
                name="oneTimeConsession"
                style="margin-left: 0"
              />
            </button>
            <div class="text-title">one-time consession of</div>
            <TextInputSmall type="number" name="oneTimeConsessionText" />
          </div>
          <div class="form-row ml-8">
            <div class="text-title">
              will be credited to your charges for the month(s) of
            </div>
          </div>
          <div class="form-row ml-8">
            <text-input
              id="oneTimeConsessionTextarea"
              v-model="oneTimeConsessionTextarea"
              rows="5"
              multiline
            />
          </div>
          <div class="form-row">
            <button>
              <CheckboxInputSmall
                type="checkbox"
                name="monthlyDiscount"
                style="margin-left: 0"
              />
            </button>
            <div class="text-title">monthly discount of</div>
            <TextInputSmall type="number" name="monthlyDiscountAmount" />
            <div class="text-title">for</div>
            <TextInputSmall type="number" name="numberOfMonths" />
            <div class="text-title">months</div>
          </div>
          <div class="form-row">
            <div class="text-title">special provisions</div>
          </div>
          <div class="form-row">
            <text-input
              id="specialProvisions"
              v-model="specialProvisions"
              rows="5"
              multiline
            />
          </div>
        </div>
      </FinalForm>
      <modal-footer :footer="footer" :primary="saveData"></modal-footer>
    </div>
  </div>
</template>

<script>
import ModalNavigation from "@/mixins/ModalNavigation";
import Loader from "@/components/ui/Loader";
import ModalFooter from "@/components/ui/modals/ModalFooter";
import InitializeFormMixin from "@/components/form/InitializeFormMixin";
import { FinalForm } from "vue-final-form";
import CheckboxInputSmall from "@/components/form/CheckboxInputSmall";
import TextInputSmall from "@/components/form/TextInputSmall";
import TextInput from '@/components/ui/TextInput';

export default {
  name: "Rent Consessions",
  components: {
    Loader,
    FinalForm,
    ModalFooter,
    CheckboxInputSmall,
    TextInputSmall,
    TextInput,
  },
  mixins: [ModalNavigation, InitializeFormMixin],
  computed: {
    initialValues() {
      return {
        oneTimeConsession: "",
        oneTimeConsessionText: "",
        oneTimeConsessionTextarea: "",
        monthlyDiscount: "",
        monthlyDiscountAmount: "",
        numberOfMonths: "",
        specialProvisions: "",
      };
    },
  },
  data() {
    return {
      loading: false,
      footer: {
        primaryButton: "save",
      },
      oneTimeConsession: "",
      oneTimeConsessionText: "",
      oneTimeConsessionTextarea: "",
      monthlyDiscount: "",
      monthlyDiscountAmount: "",
      numberOfMonths: "",
      specialProvisions: "",
    };
  },
  methods: {
    saveData() {
      this.$refs.form.formState.values.specialProvisions =
        this.specialProvisions;
      this.$refs.form.formState.values.oneTimeConsessionTextarea =
        this.oneTimeConsessionTextarea;
    },
  },
};
</script>

<style scoped>
input {
  accent-color: var(--highlightColor500) !important;
}

.stick {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
}
button {
  outline: none;
  box-shadow: none;
}
</style>
